<template>
  <div class="content-page">
    <PageHero
      :eyebrow="page.eyebrow"
      :title="page.title"
      :lede="page.lede"
      :lede-emphasis="page.ledeEmphasis"
      :actions="page.actions"
      :aside="heroAside"
    />

    <div v-if="page.overviewImage" class="deep-dive-overview">
      <ImageLightbox
        :src="page.overviewImage.src"
        :alt="page.overviewImage.alt"
      />
    </div>

    <section
      v-for="section in page.sections"
      :key="section.pillar"
      class="deep-dive-section"
    >
      <p class="deep-dive-section__pillar">{{ section.pillar }}</p>
      <h2 class="deep-dive-section__heading">{{ section.question }}</h2>
      <p v-if="section.tag" class="deep-dive-section__tag">{{ section.tag }}</p>

      <p v-if="section.philosophy" class="deep-dive-section__philosophy">
        {{ section.philosophy }}
      </p>

      <div v-if="section.image" class="deep-dive-section__image-wrap">
        <ImageLightbox
          :src="section.image.src"
          :alt="section.image.alt"
        />
      </div>

      <div class="deep-dive-section__body">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-for="(para, i) in section.body" :key="i" v-html="para" />
        <ul v-if="section.list">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <li v-for="(item, j) in section.list" :key="j" v-html="item" />
        </ul>
      </div>

      <div v-if="section.callout" class="deep-dive-section__callout">
        <h4 class="deep-dive-section__callout-title">{{ section.callout.title }}</h4>
        <ul>
          <li v-for="(item, k) in section.callout.items" :key="k">{{ item }}</li>
        </ul>
      </div>

      <div v-if="section.punchline" class="deep-dive-section__punchline">
        {{ section.punchline }}
      </div>

      <footer v-if="section.references && section.references.length" class="deep-dive-section__references">
        <p class="deep-dive-section__references-label">Further reading</p>
        <ul>
          <li v-for="ref in section.references" :key="ref.href">
            <a :href="ref.href" target="_blank" rel="noopener noreferrer">{{ ref.title }}</a>
            <span v-if="ref.note"> &mdash; {{ ref.note }}</span>
          </li>
        </ul>
      </footer>
    </section>
  </div>
</template>

<script setup>
import PageHero from '@/components/PageHero.vue'
import ImageLightbox from '@/components/ImageLightbox.vue'
import { systemPage as page } from '@/config/system'

const heroAside = {
  title: 'Five Pillars',
  copy: 'Each pillar addresses a specific failure mode in AI-assisted code.',
  blocks: [
    {
      label: 'Pillars',
      items: page.sections.map(s => `${s.pillar} — ${s.question}`),
    },
  ],
}
</script>
